import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./slider.css";

const InstructionSlider = ({ setLastSlide }) => {
  const instructionSlides = [
    {
      image: `${process.env.PUBLIC_URL}/inspection-instruction/light.png`,
      title: "Source of light",
      description: "Ensure there is ample natural light in the area for a clear image.",
    },
    {
      image: `${process.env.PUBLIC_URL}/inspection-instruction/space-around.png`,
      title: "Space around the car",
      description: "Maintain at least 150 cm around the car for 360° video capture.",
    },
    {
      image: `${process.env.PUBLIC_URL}/inspection-instruction/wash-car.png`,
      title: "Car should be washed",
      description: "Before the inspection, wash your car to ensure a high-quality capture.",
    },
    {
      image: `${process.env.PUBLIC_URL}/inspection-instruction/car-reflection.png`,
      title: "Avoid reflection",
      description: "Make sure to avoid reflections or shadows from any other objects.",
    },
    {
      image: `${process.env.PUBLIC_URL}/inspection-instruction/network.png`,
      title: "Network requirements",
      description: "A min upload speed of 1 Mbps is required for real-time image uploads.",
    },
  ];

  return (
    <div className="slider-container">
      <Carousel
        showThumbs={false}
        showStatus={false}
        infiniteLoop
        autoPlay
        interval={3000}
        onChange={(index) => {
          if (index === instructionSlides.length - 1) {
            setLastSlide(true);
          }
        }}
      >
        {instructionSlides.map((slide, idx) => (
          <div key={idx}>
            <img src={slide.image} alt={slide.title} />
            <p className="slide-title">{slide.title}</p>
            <p className="description">{slide.description}</p>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default InstructionSlider;
